import { Col, DatePicker, Row } from "antd";

import { Dayjs } from "dayjs";

const { RangePicker } = DatePicker;

interface DateRangeFilterProps {
  dateRange: [Dayjs | null, Dayjs | null] | null;
  setDateRange: (val: [Dayjs | null, Dayjs | null] | null) => void;
  label?: string;
}

const DateRangeFilter = ({
  dateRange,
  setDateRange,
  label = "Date Range:",
}: DateRangeFilterProps) => {
  return (
    <Row style={{ marginBottom: "20px", alignItems: "center" }}>
      <Col span={6}>
        <strong>{label}</strong>
      </Col>
      <Col span={18}>
        <RangePicker
          style={{ width: "100%" }}
          value={dateRange}
          onChange={(val) => setDateRange(val)}
          placeholder={["Start Date", "End Date"]}
        />
      </Col>
    </Row>
  );
};

export default DateRangeFilter;